import React from 'react';

export function LeftArrowIcon({ className }: { className?: string }) {
    return (
        <svg width='10' height='16' className={className}>
            <g fill='#213E8F' fillRule='evenodd'>
                <path d='M8.823 13.29c.44.4.46 1.09.05 1.53-.21.23-.5.34-.79.34-.26 0-.531-.09-.74-.29l-7-6.5a1.01 1.01 0 0 1-.27-.4c-.021-.07-.04-.13-.05-.2a.813.813 0 0 1 0-.38c.01-.07.029-.13.05-.2.02-.06.05-.12.08-.17.04-.06.09-.12.14-.18.02-.02.03-.028.05-.05l7-6.5c.44-.41 1.13-.38 1.53.05.41.44.39 1.13-.05 1.53l-6.15 5.71 6.15 5.71z' />
            </g>
        </svg>
    );
}
